$shm_hitalama_textbook $mol_book2
	menu_title \Учебник
	text \
	pages /
		<= Toc_page $mol_page
			title \Оглавление
			body /
				<= Toc $mol_list
					rows <= toc_rows /
						<= Toc_node*0 $mol_list
							rows <= toc_node_rows* /
								<= Toc_row* $mol_view
									sub /
										<= Toc_expand* $mol_check_expand
											checked? <=> toc_expanded*? true
											expandable <= toc_expandable* true
										<= Toc_link* $mol_link
											arg <= toc_arg* *
											sub /
												<= toc_title* \
								<= Toc_children* $mol_list
									rows <= toc_children* /
		<= Text_page $mol_page
			title <= text_title \Учебник
			body /
				<= Text $shm_hitalama_textbook_text
					param <= text_param \textbook
					text <= text \
